module.exports = __webpack_public_path__ + "static/grazzt_tasha-2f44f84aa4fb7e131b1ef0cdada1fd21.jpg";